
import React from "react";
import { Book, Globe, ScrollText } from "lucide-react";
import { FeatureCard } from "@/components/features/FeatureCard";

const FaithCards = () => {
  const faithCards = [
    {
      icon: Book,
      title: "Islam",
      description: "Primary text: Quran. We engage Islamic doctrine, Hadith, Muhammad's life, and expose Quranic contradictions. Key claim: Jesus was a prophet—not the Son of God.",
    },
    {
      icon: Book,
      title: "Judaism",
      description: "Primary texts: Torah, Talmud. We address messianic prophecy, Jewish objections to Jesus, and show Christ throughout the Hebrew Bible. Key claim: The Messiah has not yet come.",
    },
    {
      icon: Book,
      title: "Hinduism",
      description: "Primary texts: Bhagavad Gita, Vedas. We address pantheism, polytheism, the caste system, and relativism. Key claim: Many paths to God, karma, and reincarnation.",
    },
    {
      icon: ScrollText,
      title: "Mormonism (LDS)",
      description: "Primary texts: Book of Mormon, D&C, Pearl of Great Price. We highlight the false gospel and inconsistencies in Mormon scripture. Key claim: Additional scripture, new revelation.",
    },
    {
      icon: ScrollText,
      title: "Jehovah's Witnesses",
      description: "Primary texts: New World Translation, Watchtower. We correct Trinity denial and expose mistranslations. Key claim: Jesus is not God; He is Michael the Archangel.",
    },
    {
      icon: ScrollText,
      title: "Black Hebrew Israelites",
      description: "Primary texts: Various Hebrew-only reinterpretations. We challenge legalism and racial exclusivity. Key claim: Only certain ethnic groups are true Israelites.",
    },
    {
      icon: Globe,
      title: "Religious Pluralism",
      description: "We refute the claim that 'all religions lead to the same God' through Scripture, logic, and the exclusive claims of Christ.",
    },
    {
      icon: Globe,
      title: "Universalism",
      description: "We refute the claim that 'everyone will be saved in the end' through the gospel's demand for repentance and faith in Christ alone.",
    },
    {
      icon: Globe,
      title: "New Age Spirituality",
      description: "We refute claims like 'truth is inside you' and 'you manifest your reality' with biblical teaching on sin, truth, and God's sovereignty.",
    },
  ];

  return (
    <div className="my-8">
      <h2 className="text-2xl font-bold mb-6 text-gray-900">Faiths & Worldviews We Address</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {faithCards.map((card, index) => (
          <FeatureCard
            key={card.title}
            icon={card.icon}
            title={card.title}
            description={card.description}
            delay={index * 0.1}
          />
        ))}
      </div>
    </div>
  );
};

export default FaithCards;
